import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"
import { DELETE_ADDON_OVERLAY } from "shared/context/overlay/types"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"
import { useValueRef } from "shared/lib/useValueRef"
import { ProductConfigurationFormData } from "shared/types/ProductConfiguration"
import { RJSFSchema } from "shared/types/RJSF"

import { useProductConfigurationAddonOptions } from "entities/products/model/useProductConfigurationAddonOptions"

interface UseProductConfiguratorAddonsArgs {
  productType: string
  schema: RJSFSchema | null | undefined
  addonVariantKeys: string[] | null | undefined
  formData: ProductConfigurationFormData | null | undefined
  onFormDataChange: (
    nextFormData: ProductConfigurationFormData,
    fieldID?: string
  ) => void
  isLoading?: boolean | undefined
  lastChangedFieldID: string | null | undefined
  productObj?: ProductObj | null
}

export function useProductConfiguratorAddons({
  productType,
  schema,
  addonVariantKeys,
  formData,
  isLoading,
  lastChangedFieldID,
  productObj,
  onFormDataChange
}: UseProductConfiguratorAddonsArgs) {
  const formDataRef = useValueRef(formData)
  const { openOverlay: openDeleteAddonOverlay } =
    useOverlay(DELETE_ADDON_OVERLAY)

  const handleAddonDelete = useEvent((addonKey: string) => {
    const nextFormData = {
      ...formDataRef.current,
      addons: {
        ...formDataRef.current?.addons,
        [addonKey]: { value: false }
      }
    }
    if (
      formDataRef.current?.addons?.[addonKey]?.addons ||
      formDataRef.current?.addons?.[addonKey]?.product
    ) {
      openDeleteAddonOverlay({
        addonName:
          schema?.properties?.addons?.properties?.[addonKey]?.properties?.value
            ?.title,
        addonKey,
        productType,
        onDelete: () => onFormDataChange(nextFormData, addonKey)
      })
    } else {
      onFormDataChange(nextFormData, addonKey)
    }
  })

  const addonOptions = useProductConfigurationAddonOptions({
    addons: schema?.properties?.addons,
    addonVariantKeys,
    formData: formData?.addons,
    loadingFieldID: isLoading ? lastChangedFieldID : null,
    productObj
  })

  return { addonOptions, deleteAddon: handleAddonDelete }
}
